import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Place from "@mui/icons-material/Place";
import LocalOffer from "@mui/icons-material/LocalOffer";
import TouchApp from "@mui/icons-material/TouchApp";
import Info from "@mui/icons-material/Info";
import Collections from "@mui/icons-material/Collections";
import StoreMallDirectory from "@mui/icons-material/StoreMallDirectory";

// core components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";


import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, Categorias, OpcionVisibilidadPoi, OpcionSiNo, OpcionSiNoChar, TipoOthelloFieldGrid, TipoArea, ModosVisualizaNotifica, Roles, PopUpResult, TipoEntrega } from "../othelloConstantes.jsx";

import { getCurrentDataFormulario } from "../othelloFunciones.jsx";

import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloEdit  from '../componentsothello/OthelloEdit.jsx';


import NavPills from "../components/NavPills.jsx";
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import ImageUpload from "../components/ImageUpload.jsx";
import Button from "../components/Button.jsx";


import OthelloTimer from "../componentsothello/OthelloTimer.jsx";
import OthelloCheckBox from "../componentsothello/OthelloCheckBox.jsx";
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloTitulo from "../componentsothello/OthelloTitulo.jsx";
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";

export default function Pois({ ...props }) {
    const { literal, idRol, tipooficina } = props;

    const [currenturl, setcurrenturl] = React.useState("");

    const [loading, setLoading] = React.useState(true);
    const [loadingediting, setloadingediting] = React.useState(true);

    const [modoagenda, setmodoagenda] = React.useState(false);
    const [areaagenda, setareaagenda] = React.useState(null);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [statePageImagenExtra, setstatePageImagenExtra] = React.useState(DataStatePage.dsSearch);
    const [statePageAccion, setstatePageAccion] = React.useState(DataStatePage.dsSearch);
    const [statePagePromocion, setstatePagePromocion] = React.useState(DataStatePage.dsSearch);

    const [datapois, setdatapois] = React.useState(null);

    const [idiomas, setidiomas] = React.useState([]);
    const [idiomascombo, setidiomascombo] = React.useState([]);    
    const [regiones, setregiones] = React.useState([]);
    const [areas, setareas] = React.useState([]);
    const [areascombo, setareascombo] = React.useState([]);
    const [subareas, setsubareas] = React.useState([]);
    const [subareascombo, setsubareascombo] = React.useState([]);
    const [tiposactividad, settiposactividad] = React.useState(null);

    const [areaselected, setareaselected] = React.useState(null);
    const [tipoactividadselected, settipoactividadselected] = React.useState(null);
    const [changingarea, setchangingarea] = React.useState(false);    

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const [dataeditandoImagenExtra, setdataeditandoImagenExtra] = useState(null);
    const [indexeditandoImagenExtra, setindexeditandoImagenExtra] = useState(null);

    const [dataeditandoAccion, setdataeditandoAccion] = useState(null);
    const [indexeditandoAccion, setindexeditandoAccion] = useState(null);

    const [dataeditandoPromocion, setdataeditandoPromocion] = useState(null);
    const [indexeditandoPromocion, setindexeditandoPromocion] = useState(null);

    const [diasVisualizando, setdiasVisualizando] = useState(null);

    const navigate = useNavigate();

    const { search } = useLocation();
    
    React.useEffect(() => {

        if (currenturl != "" && currenturl != window.location.href) {
            setdatapois(null);
            setLoading(true);
        }
    });

    React.useEffect(() => {

        setcurrenturl(window.location.href);

        let EsAgenda= window.location.pathname.indexOf("/admin/noticias") !== -1

        setmodoagenda(EsAgenda);

        getDataPage(EsAgenda);
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const setIdPoiTiendaSelected = (selected) => {

        if (selected != null) {
            var jsonData = JSON.stringify({ id_poi: selected.id_Poi, nombre: selected.title });

            fetch('api/Data/SetIDPoiTiendaSelected', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                //Si hubo error
                if (res) {
                    //navigate('/admin/dashtienda');
                    //props.history.push('/admin/dashtienda')
                    window.location.assign('/admin/dashtienda');
                }
            }).catch(error => {

            });
        }
    }

    //Metodos Sobre POIS

    const onChangeAreaBusqueda = (valor) =>
    {
        if (subareas != null && subareas.length > 0)
        {
            let ressubareas = subareas.filter(x => x.id_Area == valor);

            if (ressubareas != null && ressubareas.length > 0) {
                let subareasCombofinal = [...ressubareas];
                subareasCombofinal.push({ id_Oficina: -1, id_SubArea: 0, id_Area: valor, cod_Area: "Todas", name: "Todas", valor: 0 });
                setsubareascombo(subareasCombofinal)
            }
            else
                setsubareascombo([]);
        }      
    }   

    const OnBuscarClick = () => {
                
        getDataPoisPage(modoagenda);
    }
   
    const getDataPage = (esagenda) =>
    {
        if (tiposactividad == null || (tiposactividad != null && tiposactividad.length == 0)) {
            fetch('api/Data/GetTiposActividad')
                .then(response => response.json())
                .then(data => {

                    let resactividades = data.map(x => {
                        let val =
                        {
                            ...x,
                            valor: x.iD_Actividad,
                            name: x.descripcion
                        };

                        return val;

                    })

                    settiposactividad(resactividades);
                });
        }

        if (idiomas == null || (idiomas != null && idiomas.length == 0)) {

            fetch('api/Data/GetIdiomas')
                .then(response => response.json())
                .then(data => {

                    let residiomas = data.map(x => {
                        let val =
                        {
                            ...x,
                            valor: x.idioma,
                            name: x.descripcion
                        };

                        return val;

                    })

                    let idiomasCombo = [...residiomas];
                    idiomasCombo.push({ id_Oficina: -1, idioma: "", name: "Todos", valor: "" })

                    setidiomas(residiomas);
                    setidiomascombo(idiomasCombo);
                });
        }

        if (regiones == null || (regiones != null && regiones.length == 0)) {

            fetch('api/Data/GetRegiones')
                .then(response => response.json())
                .then(data => {

                    let resregiones = data.map(x => {
                        let val =
                        {
                            ...x,
                            valor: x.id_Region,
                            name: x.nombreRegion
                        };

                        return val;

                    })

                    setregiones(resregiones);
                });
        }
        
        fetch('api/Data/GetAreas')
            .then(response => response.json())
            .then(data => {

                let resareas = data.map(x => {
                    let val =
                    {
                        ...x,
                        valor: x.id_Area,
                        name: x.cod_Area
                    };

                    return val;

                })

                let areasCombo = [...resareas];
                areasCombo.push({ id_Oficina: -1, id_Area: 0, cod_Area :"Todas", name: "Todas", valor: "" })

                setareas(resareas);
                setareascombo(areasCombo)

                if (esagenda) {
                    if (resareas != null && resareas.length > 0) {
                        let finalareaagenda = resareas.find(x => x.tipoArea == TipoArea.Agenda);

                        if (finalareaagenda != null)
                            setareaagenda(finalareaagenda);
                    }
                }
            });
     
        if (subareas == null || (subareas != null && subareas.length == 0)) {

            fetch('api/Data/GetSubAreasOficina')
                .then(response => response.json())
                .then(data => {

                    let ressubareas = data.map(x => {
                        let val =
                        {
                            ...x,
                            valor: x.id_SubArea,
                            name: x.descripcion
                        };

                        return val;

                    })

                    setsubareas(ressubareas);
                });
        }
       
        getDataPoisPage(esagenda);

        setLoading(false);
    }

    const getDataPoisPage = (esagenda) =>
    {
        let jsonFinal = "";

        if (esagenda != null && esagenda) {
            jsonFinal = { idioma: "", id_area: null, id_subarea:null, modoagenda: esagenda }
        }
        else
        {
            //Obtengo los datos
            let formulario = document.getElementById('formbusqueda');

            let jsonDataForm = getCurrentDataFormulario(formulario);

            jsonFinal = { ...jsonDataForm, modoagenda: esagenda };
        }

        //Si estamos en modo agenda
        var jsonData = JSON.stringify(jsonFinal);

        fetch('api/Data/GetPois', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdatapois(res);
        }).catch(error => {

        });


    }

    const getDataVacia = () => {

        fetch('api/Data/GetPoiVacio')
            .then(response => response.json())
            .then(data =>
            {
                setindexeditando(-1);
                setdiasVisualizando(data.diasVisualizar);

                if (areas != null && areas.length > 0)
                    data.id_Area = areas[0].id_Area;

                setdataeditando(data);
                setstatePage(DataStatePage.dsInsert)
                setloadingediting(false);
                setareaselected(data.id_Area > 0 ? data.id_Area : null);            
            }).catch(error => {
                setindexeditando(null);
                setdiasVisualizando("");
                setdataeditando(null);
                setstatePage(DataStatePage.dsSearch)
                setloadingediting(true);
            });;
    }

    const grabarDataPage = (event) => {

        //Altero el valor que tiene el input de dias visualizando
        try {
            //refs.form[2].value = diasVisualizando;
        }
        catch { }

        //Obtengo los datos
        //const data = new FormData(refs.form);
        let formulario = document.getElementById('formpois');
        let formData = new FormData(formulario);

        //Guardo en un auxiliar los otros valores
        let aux = dataeditando;

        fetch('api/Data/GrabarPoi', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            //Le asocio los otros valores que no han sido modificados, ya que le dio a grabar la zona de poi
            res.acciones = aux.acciones;
            res.imagenesExtras = aux.imagenesExtras;
            res.promociones = aux.promociones;


            if (indexeditando == -1) {

                var array = [...datapois];
                array.push(res);
                setdatapois(array);
            }
            else {
                var array = [...datapois];
                array[indexeditando] = res;
                setdatapois(array);
            }

            setdiasVisualizando(res.diasVisualizar);
            setdataeditando(res);            
            setalert(PopUpResult.OK);
            
            //autoCloseAlert();
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPage = () => 
    {
        cancelarDataPage();
        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVacia();
        setindexeditando(-1);
        setdiasVisualizando("");
    }

    const cancelarDataPage = () => {
        setindexeditando(null);
        setdiasVisualizando("");
        setdataeditando(null);
        setstatePage(DataStatePage.dsSearch);
        setloadingediting(true);
    }

    const deshacerDataPage = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditando == -1)
        {        
            setdataeditando(null);
            setstatePage(DataStatePage.dsSearch);
            setloadingediting(true);
        }
        //Sino, es que estabamos en un item valido
        else {
            //Inicializo a los datos que tenia cuando se puso a editar el poi
            if (dataeditando != null)
                setdiasVisualizando(dataeditando.diasVisualizar);

            //Actualizo la pantalla
            //forceUpdate()
        }
    }

    const onChangeArea = (valor) => {
        if (areaselected != valor) {

            var object = {};
            let formulario = document.getElementById('formpois');
            let formData = new FormData(formulario);
            formData.forEach((value, key) => { object[key] = value });

            var final =
            {
                ...object,
                lat: object.latStringAux,
                lon: object.lonStringAux,
                imagenesExtras: dataeditando.imagenesExtras,
                acciones: dataeditando.acciones,
                promociones: dataeditando.promociones,
                diasVisualizar: diasVisualizando
            }

            setdataeditando(final);
            setareaselected(valor);
        }
    }

    //let areasCombo = [...resareas];
    //areasCombo.push({ id_Oficina: -1, id_Area: 0, cod_Area: "Todas", name: "Todas", valor: "" })


    const onLimpiarFechaNotificado = (idpoi) => {
        if (idpoi > 0) {
            var jsonData = JSON.stringify(idpoi);

            fetch('api/Data/LimpiarFechaNotificadoPoi', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {

                    let valor = dataeditando;
                    valor.notificado = null;
                    setdataeditando(valor);
                }
            }).catch(error => {

            });
        }
    }

    const onChangeDiaCheckBox = (id, valor) => {

        //Si tenemo valor editando
        if (dataeditando != null && diasVisualizando != null) {
            let diasvisu = diasVisualizando;

            //Si me dice que se ha seleccionado el check
            if (valor) {

                //Si no esta dentro de los dias a visualizar
                if (diasvisu.indexOf(id) < 0) {
                    diasvisu = diasvisu + id;
                }
            }
            //sino, es que debemos eliminarlo
            else {
                diasvisu = diasvisu.replace(id, "");
            }

            setdiasVisualizando(diasvisu);
        }
    }

    const onClosePopUpResult = () => {
        setalert("");
    }

    //Metodo sobre Imagenes Extras

    const getDataVaciaImagenExtra = () => {

        var jsonData = JSON.stringify(dataeditando.id_Poi);

        fetch('api/Data/GetImagenExtraVacia', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res =>
        {
            setdataeditandoImagenExtra(res);
            setstatePageImagenExtra(DataStatePage.dsInsert);
        }).catch(error => {
            setdataeditandoImagenExtra(null);
        });
    }

    const grabarDataPageImagenExtra = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formextras');
        let formData = new FormData(formulario);
        //const data = new FormData(refs.form);

        fetch('api/Data/GrabarImagenExtra', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            let editandofinal = dataeditando;

            if (editandofinal.imagenesExtras == null)
                editandofinal.imagenesfinal = [];

            if (indexeditandoImagenExtra == -1) 
                editandofinal.imagenesExtras.push(res);
            else
                editandofinal.imagenesExtras[indexeditandoImagenExtra] = res;

            setdataeditando(editandofinal);
            setdataeditandoImagenExtra(null);
            setindexeditandoImagenExtra(null);
            setstatePageImagenExtra(DataStatePage.dsSearch)
            setalert(PopUpResult.OK);        
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPageImagenExtra = () => {

        getDataVaciaImagenExtra();
        setindexeditandoImagenExtra(-1);        
    }

    const cancelarDataPageImagenExtra = () => {
        setdataeditandoImagenExtra(null);
        setindexeditandoImagenExtra(null);
        setstatePageImagenExtra(DataStatePage.dsSearch)
    }

    const deshacerDataPageImagenExtra = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditandoImagenExtra == -1)
            setstatePageImagenExtra(DataStatePage.dsSearch)            
        //Sino, es que estabamos en un item valido
        //else
            //forceUpdate()
    }

    //Metodo sobre Acciones

    const getDataVaciaAccion = () => {

        var jsonData = JSON.stringify(dataeditando.id_Poi);

        fetch('api/Data/GetAccionVacia', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {

            setdataeditandoAccion(res);
            setstatePageAccion(DataStatePage.dsInsert)
            settipoactividadselected(null);        
        }).catch(error => {
            setdataeditandoAccion(null);            
        });
    }

    const grabarDataPageAccion = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formaccion');
        let formData = new FormData(formulario);
        //const data = new FormData(refs.form);        

        fetch('api/Data/GrabarAccion', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            let editandofinal = dataeditando;

            if (editandofinal.acciones == null)
                editandofinal.acciones = [];

            if (indexeditandoAccion == -1)
                editandofinal.acciones.push(res);
            else
                editandofinal.acciones[indexeditandoAccion] = res;

            setdataeditando(editandofinal);
            setdataeditandoAccion(null);
            setindexeditandoAccion(null);
            setstatePageAccion(DataStatePage.dsSearch)
            setalert(PopUpResult.OK);
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPageAccion = () => {

        getDataVaciaAccion();
        setindexeditandoAccion(-1);
    }

    const cancelarDataPageAccion = () => {
        setdataeditandoAccion(null);
        setindexeditandoAccion(null);
        setstatePageAccion(DataStatePage.dsSearch)
    }

    const deshacerDataPageAccion = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditandoAccion == -1)
            setstatePageAccion(DataStatePage.dsSearch)
        //Sino, es que estabamos en un item valido
        //else
            //forceUpdate()
    }

    const onChangeTipoActividad = (valor) => {
        if (tipoactividadselected != valor)
            settipoactividadselected(valor);
    }

    //Metodo sobre Promociones

    const getDataVaciaPromocion = () => {

        var jsonData = JSON.stringify(dataeditando.id_Poi);

        fetch('api/Data/GetPromocionVacia', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdataeditandoPromocion(res);
            setstatePagePromocion(DataStatePage.dsInsert);
        }).catch(error => {
            setdataeditandoPromocion(null);
        });
    }

    const grabarDataPagePromocion = (event) => {
        //Obtengo los datos
        let formulario = document.getElementById('formpromo');
        let formData = new FormData(formulario);
        //const data = new FormData(refs.form);

        fetch('api/Data/GrabarPromocion', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            let editandofinal = dataeditando;

            if (editandofinal.promociones == null)
                editandofinal.promociones = [];

            if (indexeditandoPromocion == -1)
                editandofinal.promociones.push(res);
            else
                editandofinal.promociones[indexeditandoPromocion] = res;

            setdataeditando(editandofinal);
            setdataeditandoPromocion(null);
            setindexeditandoPromocion(null);
            setstatePagePromocion(DataStatePage.dsSearch)
            setalert(PopUpResult.OK);                      
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPagePromocion = () => {

        getDataVaciaPromocion();
        setindexeditandoPromocion(-1);
    }

    const cancelarDataPagePromocion = () => {
        setdataeditandoPromocion(null);
        setindexeditandoPromocion(null);
        setstatePagePromocion(DataStatePage.dsSearch)
    }

    const deshacerDataPagePromocion = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditandoPromocion == -1)
            setstatePagePromocion(DataStatePage.dsSearch)
        //Sino, es que estabamos en un item valido
        //else
          //  forceUpdate()
    }

    //METODO SOBRE EL GRID POIS

    const editGridDataPage = (valor, index) => {

        setloadingediting(true);
        setdataeditando(null);
        //setState({ dataeditando: null, loadingediting: true });

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Poi);

            fetch('api/Data/GetPoi', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                setindexeditando(index);
                setdiasVisualizando(res.diasVisualizar);
                setdataeditando(res);
                setstatePage(DataStatePage.dsEdit)
                setloadingediting(false);
                setareaselected(res.id_Area);
                setalert(null);            
            }).catch(error => {

            });
        }
    }

    const deleteGridDataPage = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Poi);

            fetch('api/Data/EliminarPoi', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditando(null);
                    setindexeditando(null);                    
                    setdiasVisualizando("");
                    setstatePage(DataStatePage.dsSearch);

                    if (datapois != null) {
                        var array = [...datapois]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        //Modificao el estado de data para que refresque la pantalla
                        setdatapois(array)
                        setalert(PopUpResult.OK);                    
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODO SOBRE EL GRID IMAGENES EXTRAS

    const editGridDataPageImagenExtra = (valor, index) => {

        setdataeditandoImagenExtra(valor);
        setindexeditandoImagenExtra(index);
        setstatePageImagenExtra(DataStatePage.dsEdit);
    }

    const deleteGridDataPageImagenExtra = (valor, index) =>
    {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Extra_Img);

            fetch('api/Data/EliminarImagenExtra', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res)
                {
                    if (dataeditando.imagenesExtras != null) {
                        var array = [...dataeditando.imagenesExtras]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        let datafinal = dataeditando;

                        //Actualizo las promociones con el nuevo valor
                        datafinal.imagenesExtras = array;

                        setdataeditando(datafinal);

                        //Si todo salie correcto limpio los valores de edicion
                        setdataeditandoImagenExtra(null);
                        setindexeditandoImagenExtra(null);

                        //Modificao el estado de data para que refresque la pantalla
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODO SOBRE EL GRID ACCIONES

    const editGridDataPageAccion = (valor, index) => {

        setdataeditandoAccion(valor);
        setindexeditandoAccion(index);
        setstatePageAccion(DataStatePage.dsEdit);
        settipoactividadselected(valor.activityType);
    }

    const deleteGridDataPageAccion = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_PoiAction);

            fetch('api/Data/EliminarAccion', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {

                    if (dataeditando.acciones != null) {
                        var array = [...dataeditando.acciones]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        let datafinal = dataeditando;

                        //Actualizo las promociones con el nuevo valor
                        datafinal.acciones = array;

                        setdataeditando(datafinal);
                       
                        //Si todo salie correcto limpio los valores de edicion
                        setdataeditandoAccion(null);
                        setindexeditandoAccion(null);

                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODO SOBRE EL GRID PROMOCIONES

    const editGridDataPagePromocion =  (valor, index) => {

        setdataeditandoPromocion(valor);
        setindexeditandoPromocion(index);
        setstatePagePromocion(DataStatePage.dsEdit);
    }

    const deleteGridDataPagePromocion = (valor, index) =>
    {
        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Promocion);

            fetch('api/Data/EliminarPromocion', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {


                    if (dataeditando.promociones != null) {
                        var array = [...dataeditando.promociones]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        let datafinal = dataeditando;

                        //Actualizo las promociones con el nuevo valor
                        datafinal.promociones = array;

                        setdataeditando(datafinal);

                        //Si todo salie correcto limpio los valores de edicion
                        setdataeditandoPromocion(null);
                        setindexeditandoPromocion(null);

                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    //Metodos render POIS

    function renderSearchPOIS(pois)
    {
        let name = tipooficina == 3 ? "Establecimiento" : "Punto de Interes";
        let cabeceros = idRol == Roles.SuperUsuario ? [name, "Idioma", "Area", "Sub Area", "Poi"] : [name, "Idioma", "Area", "Sub Area"];
        let valoreshow = idRol == Roles.SuperUsuario ? ["title", "idioma", "id_Area", "id_SubArea", "id_Poi"] : ["title", "idioma", "id_Area", "id_SubArea"];

        if (modoagenda) {
            let Cabecera = areaagenda != null ? areaagenda.cod_Area : "";

            cabeceros = [Cabecera, "Notificacion", "Poi"];
            valoreshow = ["title", "fNotificacion", "id_Poi"];
        }

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "idioma", items: idiomas });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "id_Area", items: areas });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "id_SubArea", items: subareas, omitir: true });

        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloDateTime, fieldname: "fNotificacion" });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={pois} datasourcefields={datasourceFields} onEdit={editGridDataPage} onDelete={deleteGridDataPage} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEditPOIS() {

        if (dataeditando != null) {
            let name = tipooficina == 3 ? "Establecimiento" : "Punto de Interes";

            //Ponemos el nombre general el valor local que tenemos en dicho momento
            let Nombre = loadingediting ? <p><CircularProgress color="secondary" /></p> :
                (dataeditando != null && dataeditando.id_Poi > 0 ? dataeditando.title : (modoagenda ? "Nuevo registro" : "Nuevo " + name));

            //Si estamos cargando el poi ponemos el buscando, sino, renderizamos los datos generales del poi actual
            let datosGeneralesPoi = loadingediting ? <p><CircularProgress color="secondary" /></p>
                : renderInsertEditDatosGenerales(dataeditando)

            //Si estamos cargando el poi ponemos el buscando, sino, renderizamos los datos generales del poi actual
            let datosImagenesExtraPoi = loadingediting ? <p><CircularProgress color="secondary" /></p>
                : renderOpcionesImagenesExtra(dataeditando.imagenesExtras)

            // Si estamos cargando el poi ponemos el buscando, sino, renderizamos los datos generales del poi actual
            let datosAccionesPoi = loadingediting ? <p><CircularProgress color="secondary" /></p>
                : renderOpcionesAcciones(dataeditando.acciones)

            // Si estamos cargando el poi ponemos el buscando, sino, renderizamos los datos generales del poi actual
            let datosPromocionesPoi = loadingediting ? <p><CircularProgress color="secondary" /></p>
                : renderOpcionesPromociones(dataeditando.promociones)


            let tabs = [];

            if (modoagenda) {

                tabs = [
                    {
                        tabButton: "Datos Generales",
                        tabIcon: Info,
                        tabContent: (datosGeneralesPoi)
                    }];

                if (dataeditando != null && dataeditando.id_Poi > 0) {
                    tabs.push(
                        {
                            tabButton: "Imagenes Extra",
                            tabIcon: Collections,
                            tabContent: (datosImagenesExtraPoi)
                        });

                    tabs.push(
                        {
                            tabButton: "Acciones",
                            tabIcon: TouchApp,
                            tabContent: (datosAccionesPoi)
                        });
                }
            }
            else {
                tabs = [
                    {
                        tabButton: "Datos Generales",
                        tabIcon: Info,
                        tabContent: (datosGeneralesPoi)
                    }];

                if (dataeditando != null && dataeditando.id_Poi > 0) {
                    tabs.push({
                        tabButton: "Imagenes Extra",
                        tabIcon: Collections,
                        tabContent: (datosImagenesExtraPoi)
                    });
                    tabs.push({
                        tabButton: "Acciones",
                        tabIcon: TouchApp,
                        tabContent: (datosAccionesPoi)
                    });
                    tabs.push({
                        tabButton: "Promociones",
                        tabIcon: LocalOffer,
                        tabContent: (datosPromocionesPoi)
                    });
                }
            }


            return (<OthelloTituloPanelData icon="place" titulo={Nombre} margentop={4}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <NavPills
                        color="rose"
                        tabs={tabs}
                    />
                </div>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    //Metodos render datos Generales POI

    function renderInsertEditDatosGenerales(poi)
    {
        if (poi != null) {
            let subareasshow = subareas != null ? subareas.filter(x => x.id_Area == areaselected) : null;
            let areaactual = areas != null ? areas.find(x => x.id_Area == areaselected) : null;

            return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
                <Grid container xs={12}>
                    <Grid item xs={12}>
                        <OthelloBotonera statePage={statePage} onNuevo={idRol != Roles.Usuario ? nuevoDataPage : null} onGrabar={grabarDataPage} onCancel={cancelarDataPage} onDeshacer={deshacerDataPage} />
                    </Grid>
                </Grid>
                <Grid container xs={12}>
                    <Grid item xs={6} sm={2}>
                        {tipooficina == 3 || (poi != null && poi.ventaActiva != null && poi.ventaActiva == 1) ? <Button color='facebook' size="sm" onClick={() => setIdPoiTiendaSelected(poi)} ><StoreMallDirectory />Acceso a Tienda</Button> : ""}
                    </Grid>
                </Grid>
                <form id="formpois" >
                    <input id="id_Oficina" name="id_Oficina" type="hidden" value={poi.id_Oficina} />
                    <input id="Id_Poi" name="id_Poi" type="hidden" value={poi.id_Poi} />
                    <input id="diasVisualizar" name="diasVisualizar" type="hidden" value={diasVisualizando} />
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Datos Generales" />
                        </Grid>
                    </Grid>
                    <Grid container xs={10}>
                        <Grid item xs={5} sm={4} lg={3}>
                            <OthelloEdit label="Nombre" fieldname="title" currentvalue={poi.title} />
                        </Grid>
                        <Grid item xs={5} sm={3} lg={1}>
                            <OthelloComboBox label='Visible' fieldname="visible" items={OpcionVisibilidadPoi} currentvalue={poi.visible} />
                        </Grid>
                        {
                            !modoagenda && regiones != null && regiones.length > 0 ?
                                <Grid item xs={5} sm={4} lg={2}>
                                    <OthelloComboBox label='Region' fieldname="id_Region" items={regiones} currentvalue={poi.id_Region} />
                                </Grid> :
                                <input id="Id_Region" name="id_Region" type="hidden" value={0} />
                        }
                        {
                            !modoagenda ?
                                <Grid item xs={5} sm={3} lg={2}>
                                    <OthelloEdit label="Orden Visual" fieldname="ordenVisual" currentvalue={poi.ordenVisual} />
                                </Grid> : ""
                        }
                        {
                            modoagenda || idRol != Roles.SuperUsuario ?

                                <input id="Afiliado" name="afiliado" type="hidden" value={poi.afiliado != null ? poi.afiliado : (modoagenda ? 1 : 0)} /> :
                                <Grid item xs={5} sm={3} lg={2}>
                                    <OthelloComboBox label='Afiliado' fieldname="afiliado" items={OpcionSiNo} currentvalue={poi.afiliado} />
                                </Grid>
                        }
                        {
                            modoagenda ?
                                <input id="Idioma" name="idioma" type="hidden" value={poi.idioma != null && poi.idioma != "" ? poi.idioma : idiomas[0].idioma} /> :
                                <input id="Idioma" name="idioma" type="hidden" value={areaactual != null ? areaactual.idioma : idiomas[0].idioma} />
                        }
                    </Grid>
                    <Grid container xs={10}>
                        {
                            modoagenda ?
                                <input id="Id_Area" name="id_Area" type="hidden" value={areaagenda != null ? areaagenda.id_Area : -1} /> :
                                <Grid item xs={5} sm={3} lg={2}>
                                    <OthelloComboBox label='Area' fieldname="id_Area" items={areas} currentvalue={poi.id_Area} onChange={onChangeArea} />
                                </Grid>
                        }
                        {
                            !modoagenda && subareasshow != null && subareasshow.length > 0 ?
                                (<Grid item xs={5} sm={3} lg={2}>
                                    <OthelloComboBox label='Sub Area' fieldname="id_SubArea" items={subareasshow} currentvalue={poi.id_SubArea != null ? poi.id_SubArea : null} />
                                </Grid>) : ""
                        }
                        <Grid item xs={5} sm={2} lg={1}>
                            <OthelloEdit label="Latitud" fieldname="latStringAux" currentvalue={poi.lat} />
                        </Grid>
                        <Grid item xs={5} sm={2} lg={1}>
                            <OthelloEdit label="Longitud" fieldname="lonStringAux" currentvalue={poi.lon} />
                        </Grid>
                        {
                            !modoagenda ?
                                <Grid item xs={5} sm={4} lg={3}>
                                    <OthelloComboBox label='Categoria' fieldname="categoria" items={Categorias} currentvalue={poi.categoria} />
                                </Grid> : ""
                        }

                        {
                            !modoagenda ?
                                <Grid item xs={6} sm={4} lg={2}>
                                    <OthelloEdit label="Maestro (Id_Poi)" fieldname="id_Maestro" currentvalue={poi.id_Maestro != null ? poi.id_Maestro : ""} />
                                </Grid> : ""
                        }
                        <Grid item xs={5} sm={2} lg={1}>
                            <OthelloEdit label="Latitud Fin" fieldname="latFinStringAux" currentvalue={poi.latFin} />
                        </Grid>
                        <Grid item xs={5} sm={2} lg={1}>
                            <OthelloEdit label="Longitud Fin" fieldname="lonFinStringAux" currentvalue={poi.lonFin} />
                        </Grid>
                    </Grid>
                    <Grid container xs={10}>
                        <Grid item xs={10} sm={10} lg={5}>
                            <OthelloEdit label="Direccion" fieldname="footNote" currentvalue={poi.footNote} rows={2} />
                        </Grid>
                        <Grid item xs={10} sm={10} lg={5}>
                            <OthelloEdit label="WayPoints Auto (lat,lon|lat,lon)" fieldname="wayPoints" currentvalue={poi.wayPoints != null ? poi.wayPoints : ""} rows={2} />
                        </Grid>
                    </Grid>
                    <Grid container xs={10}>
                        <Grid item xs={10} sm={10}>
                            <OthelloEdit label="Descripcion Breve" fieldname="description" currentvalue={poi.description} rows={3} />
                        </Grid>
                    </Grid>
                    <Grid container xs={10}>
                        <Grid item xs={10} sm={10}>
                            <OthelloEdit label="Descripcion Completa" fieldname="descripcionLarga" currentvalue={poi.descripcionLarga} rows={10} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Notificaciones - Visualizacion" />
                        </Grid>
                    </Grid>
                    {
                        modoagenda || (areaactual != null && (areaactual.tipoArea == TipoArea.Calendario || areaactual.permiteNotificar == 1)) ?
                            <Grid container xs={10}>
                                <Grid item xs={10} sm={2}>
                                    <OthelloComboBox label='Se debe Notificar' fieldname="notificacion" items={OpcionSiNo} currentvalue={poi.notificacion} />
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <OthelloTimer label={areaselected != null && areaselected.tipoArea == TipoArea.Calendario ? "Fecha" : "Dia a notificar"} fieldname="fNotificacion" currentvalue={poi.fNotificacion} />
                                </Grid>
                                {
                                    poi.notificado != null ? <Grid item xs={10} sm={2}><b>{new Date(poi.notificado).toLocaleTimeString()}</b> <Button size="sm" color="primary" onClick={() => onLimpiarFechaNotificado(poi.id_Poi)}>Limpiar</Button> </Grid> : ""
                                }
                            </Grid>
                            : ""
                    }
                    <br />
                    <Grid container xs={10}>
                        <Grid item xs={10} sm={4} lg={1.5}>
                            <OthelloComboBox label='Realizar la accion de:' fieldname="visualizaNotifica" items={ModosVisualizaNotifica} currentvalue={poi.visualizaNotifica} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={2} lg={1.5}>
                            <OthelloCheckBox label="Lunes" fieldname="L" checked={diasVisualizando != null && diasVisualizando.indexOf("L") >= 0} onChange={onChangeDiaCheckBox} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={2} lg={1.5}>
                            <OthelloCheckBox label="Martes" fieldname="M" checked={diasVisualizando != null && diasVisualizando.indexOf("M") >= 0} onChange={onChangeDiaCheckBox} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={3} lg={1.5} >
                            <OthelloCheckBox label="Miercoles" fieldname="X" checked={diasVisualizando != null && diasVisualizando.indexOf("X") >= 0} onChange={onChangeDiaCheckBox} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={2} lg={1.5}>
                            <OthelloCheckBox label="Jueves" fieldname="J" checked={diasVisualizando != null && diasVisualizando.indexOf("J") >= 0} onChange={onChangeDiaCheckBox} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={2} lg={1.5}>
                            <OthelloCheckBox label="Viernes" fieldname="V" checked={diasVisualizando != null && diasVisualizando.indexOf("V") >= 0} onChange={onChangeDiaCheckBox} />
                        </Grid>
                        <Grid item xs={12} sm={3} md={2} lg={1.5}>
                            <OthelloCheckBox label="Sabado" fieldname="S" checked={diasVisualizando != null && diasVisualizando.indexOf("S") >= 0} onChange={onChangeDiaCheckBox} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={2} lg={1.5}>
                            <OthelloCheckBox label="Domingo" fieldname="D" checked={diasVisualizando != null && diasVisualizando.indexOf("D") >= 0} onChange={onChangeDiaCheckBox} />
                        </Grid>
                    </Grid>
                    <br />
                    <Grid container xs={10}>
                        <Grid item xs={6} sm={5} lg={2}>
                            <OthelloTimer label="Fecha Inicio" fieldname="fInicioVisualizar" currentvalue={poi.fInicioVisualizar} />
                        </Grid>
                        <Grid item xs={6} sm={5} lg={2}>
                            <OthelloTimer label="Fecha Fin" fieldname="fFinalVisualizar" currentvalue={poi.fFinalVisualizar} />
                        </Grid>
                    </Grid>
                    {!modoagenda ?
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <br />
                                <OthelloTitulo titulo="Datos Establecimiento" />
                            </Grid>
                        </Grid>
                        : ""}
                    {!modoagenda ?
                        <Grid container xs={10}>
                            <Grid item xs={6} sm={10} lg={4}>
                                <OthelloEdit label="Horario" fieldname="horario" currentvalue={poi.horario} rows={2} />
                            </Grid>
                            <Grid item xs={6} sm={5} lg={3}>
                                <OthelloEdit label="Franja Precios" fieldname="franjaPrecio" currentvalue={poi.franjaPrecio} />
                            </Grid>
                            <Grid item xs={6} sm={5} lg={3}>
                                <OthelloComboBox label='Tipo Entrega' fieldname="tipoEntrega" items={TipoEntrega} currentvalue={poi.tipoEntrega} />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <OthelloComboBox label='Venta Activa' fieldname="ventaActiva" items={OpcionSiNo} currentvalue={poi.ventaActiva} />
                            </Grid>
                            <Grid item xs={6} sm={10} lg={4}>
                                <OthelloEdit label="Precio Envio Gratis" fieldname="precioEnvioGratisString" currentvalue={poi.precioEnvioGratis} />
                            </Grid>
                            <Grid item xs={6} sm={5} lg={3}>
                                <OthelloEdit label="PrecioPortes" fieldname="precioPortesString" currentvalue={poi.precioPortes} />
                            </Grid>
                            <Grid item xs={6} sm={5} lg={3}>
                                <OthelloEdit label="Precio Minimo Pedido" fieldname="precioMinimoPedidoString" currentvalue={poi.precioMinimoPedido} />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <OthelloEdit label='EMail Notificaciones' fieldname="eMailNotificaciones" currentvalue={poi.eMailNotificaciones} />
                            </Grid>
                        </Grid>
                        : ""}
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Imagenes Destacadas" />
                        </Grid>
                    </Grid>
                    <Grid container xs={10}>
                        <Grid item xs={10} sm={5} lg={2}>
                            <br />
                            <p>Pequeña (300x225px)</p>
                            <ImageUpload
                                id="ImageUrl" name="imageUrl"
                                imageUrl={poi.imageUrl}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={10} sm={5} lg={2}>
                            <br />
                            <p>Grande (512x384px)</p>
                            <ImageUpload
                                id="ImageUrlBig" name="imageUrlBig"
                                imageUrl={poi.imageUrlBig}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                    </Grid>
                </form>
            </div>
            )
        }
        else
            return "";
    }

    //Metodos render Imagenes Extras

    function renderOpcionesImagenesExtra( imagenes) {

        let busquedaImagenes = renderSearchImagenesExtra( imagenes);

        let edicionImagenes = statePageImagenExtra == DataStatePage.dsEdit || statePageImagenExtra == DataStatePage.dsInsert ? renderInsertEditImagenExtra( dataeditandoImagenExtra) : "";

        //#99d9b7
        return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={12}>
                <Grid item xs={11} >
                    {edicionImagenes}
                </Grid>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePageImagenExtra} onNuevo={nuevoDataPageImagenExtra} forzarnuevo={true} />
                </Grid>
                <Grid item xs={12} >
                    {busquedaImagenes}
                </Grid>
            </Grid>
        </div>
        );
    }

    function renderSearchImagenesExtra( imagenes) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = idRol == Roles.SuperUsuario ? ["Imagen", "ID"] : ["Imagen"];
        let valoreshow = idRol == Roles.SuperUsuario ? ["imageUrl", "id_Extra_Img"] : ["imageUrl"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "imageUrl", items: [] });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={imagenes} datasourcefields={datasourceFields} onEdit={editGridDataPageImagenExtra} onDelete={deleteGridDataPageImagenExtra} permitefiltrar={false} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderInsertEditImagenExtra(imagenextra) {

        if (imagenextra != null) {
            let Nombre = imagenextra != null && imagenextra.id_Extra_Img > 0 ? "Editar Imagen" : "Nueva Imagen";

            return (<OthelloTituloPanelData icon="collections" titulo={Nombre} margentop={4}>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePageImagenExtra} onNuevo={nuevoDataPageImagenExtra} onGrabar={grabarDataPageImagenExtra} onCancel={cancelarDataPageImagenExtra} onDeshacer={deshacerDataPageImagenExtra} />
                    </Grid>
                </Grid>
                <form id="formextras" >
                    <Grid container xs={12}>
                        <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={imagenextra.id_Oficina} />
                        <input id="Id_Poi" name="Id_Poi" type="hidden" value={imagenextra.id_Poi} />
                        <input id="Id_Extra_Img" name="Id_Extra_Img" type="hidden" value={imagenextra.id_Extra_Img} />
                        <input id="NombrePoi" name="NombrePoi" type="hidden" value={dataeditando.title} />
                        <Grid item xs={12} sm={2}>
                            <br />
                            <legend>Imagen (512x384px)</legend>
                            <ImageUpload
                                id="imageUrl" name="imageUrl"
                                imageUrl={imagenextra.imageUrl}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                    </Grid>
                </form>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }
    //Metodos render Acciones

    function renderOpcionesAcciones( acciones) {

        let busquedaacciones = renderSearchAcciones( acciones);

        let edicionacciones = statePageAccion == DataStatePage.dsEdit || statePageAccion == DataStatePage.dsInsert ? renderInsertEditAccion( dataeditandoAccion) : "";

        //#99d9b7
        return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={12}>
                <Grid item xs={11} >
                    {edicionacciones}
                </Grid>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePageAccion} onNuevo={nuevoDataPageAccion} forzarnuevo={true} />
                </Grid>
                <Grid item xs={12} >
                    {busquedaacciones}
                </Grid>
            </Grid>
        </div>
        );
    }

    function renderSearchAcciones( acciones) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = idRol == Roles.SuperUsuario ? ["Nombre Accion", "Tipo de Accion", "Orden Visual", "Accion", "ID"] : ["Nombre Accion", "Tipo de Accion", "Orden Visual", "Accion"];
        let valoreshow = idRol == Roles.SuperUsuario ? ["label", "activityType", "ordenVisual", "uri", "id_PoiAction"] : ["label", "activityType", "ordenVisual", "uri"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "activityType", items: tiposactividad });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloEditLargo, fieldname: "uri", width: 250 });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={acciones} datasourcefields={datasourceFields} onEdit={editGridDataPageAccion} onDelete={deleteGridDataPageAccion} permitefiltrar={false} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    const getLabelUri = (TipoActividad) => {
        //Si existe el valor
        if (TipoActividad > 0) {
            if (TipoActividad == 1)
                return "Pagina web";
            else if (TipoActividad == 2)
                return "Ubicación del audio";
            else if (TipoActividad == 4)
                return "Numero de telefono";
            else if (TipoActividad == 5)
                return "Dirección de correo";
            else if (TipoActividad == 38)
                return "";
            else if (TipoActividad == 39)
                return "";
            else if (TipoActividad == 19)
                return "Accion (Ej:whatsapp://send?phone=+34....)";
            else
                return "Accion";
        }
        else
            return "Accion";
    }

    function renderInsertEditAccion(accion) {

        if (accion != null) {
            let Nombre = accion != null && accion.id_PoiAction > 0 ? "Editar Accion" : "Nueva Accion";

            return (<OthelloTituloPanelData icon="touch_app" titulo={Nombre} margentop={4}>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePageAccion} onNuevo={nuevoDataPageAccion} onGrabar={grabarDataPageAccion} onCancel={cancelarDataPageAccion} onDeshacer={deshacerDataPageAccion} />
                    </Grid>
                </Grid>
                <form id="formaccion" >
                    <Grid container xs={12}>
                        <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={accion.id_Oficina} />
                        <input id="Id_Poi" name="Id_Poi" type="hidden" value={accion.id_Poi} />
                        <input id="Id_PoiAction" name="Id_PoiAction" type="hidden" value={accion.id_PoiAction} />
                        <Grid item xs={12} sm={4}>
                            <OthelloEdit label="Label" fieldname="Label" currentvalue={accion.label} />
                        </Grid>
                        <Grid item xs={10} sm={3}>

                            <OthelloComboBox label='Tipo de Accion' fieldname="ActivityType" items={idRol != Roles.SuperUsuario ?
                                tiposactividad.filter(x => x.iD_Actividad != 38 && x.iD_Actividad != 39) : tiposactividad} currentvalue={accion.activityType} onChange={onChangeTipoActividad} />

                        </Grid>
                        <Grid item xs={10} sm={2}>
                            <OthelloEdit label="Orden Visual" fieldname="OrdenVisual" currentvalue={accion.ordenVisual} />
                        </Grid>
                        {
                            !(tipoactividadselected == 38 || tipoactividadselected == 39) ?
                                <Grid item xs={10} sm={3}>
                                    <OthelloEdit label={getLabelUri(tipoactividadselected)} fieldname="Uri" currentvalue={accion.uri} />
                                </Grid> : ""
                        }
                        {
                            tipoactividadselected == 20 ?
                                <Grid item xs={12} sm={12}>
                                    <OthelloEdit label="WayPoints (lat,lon|lat,lon)" fieldname="wayPoints" currentvalue={accion.wayPoints != null ? accion.wayPoints : ""} rows="6"/>
                                </Grid> : ""
                        }
                    </Grid>
                    <Grid container xs={12}>

                        {
                            tipoactividadselected == 2 || tipoactividadselected == 6 || tipoactividadselected == 7 || tipoactividadselected == 8 || tipoactividadselected == 18 ?
                                (<Grid item xs={12} sm={2}>
                                    <br />
                                    <legend>Archivo</legend>
                                    <ImageUpload
                                        id="Extension" name="Extension"
                                        imageUrl={""}
                                        addButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        changeButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        removeButtonProps={{
                                            color: "danger",
                                            round: true
                                        }}
                                    />
                                </Grid>) : ""
                        }
                    </Grid>
                </form>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    //Metodos render Promociones

    function renderOpcionesPromociones( promos) {

        let busquedaPromos = renderSearchPromociones( promos);

        let edicionPromos = statePagePromocion == DataStatePage.dsEdit || statePagePromocion == DataStatePage.dsInsert ? renderInsertEditPromocion( dataeditandoPromocion) : "";

        //#99d9b7
        return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={12}>
                <Grid item xs={11} >
                    {edicionPromos}
                </Grid>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePagePromocion} onNuevo={nuevoDataPagePromocion} forzarnuevo={true} />
                </Grid>
                <Grid item xs={12} >
                    {busquedaPromos}
                </Grid>
            </Grid>
        </div>
        );
    }

    function renderSearchPromociones( promos) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = idRol == Roles.SuperUsuario ? ["Codigo", "Promocion", "Fecha Final", "Activada", "ID"] : ["Codigo", "Promocion", "Fecha Final", "Activada"];
        let valoreshow = idRol == Roles.SuperUsuario ? ["codigoPromo", "promo", "fechValido", "activada", "id_Promocion"] : ["codigoPromo", "promo", "fechValido", "activada"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "activada", items: OpcionSiNoChar });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloDate, fieldname: "fechValido" });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={promos} datasourcefields={datasourceFields} onEdit={editGridDataPagePromocion} onDelete={deleteGridDataPagePromocion} permitefiltrar={false} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderInsertEditPromocion(promo) {

        if (promo != null) {
            let Nombre = promo != null && promo.id_Promocion > 0 ? "Editar Promocion" : "Nueva Promocion";

            return (<OthelloTituloPanelData icon="local_offer" titulo={Nombre} margentop={4}>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePagePromocion} onNuevo={nuevoDataPagePromocion} onGrabar={grabarDataPagePromocion} onCancel={cancelarDataPagePromocion} onDeshacer={deshacerDataPagePromocion} />
                    </Grid>
                </Grid>
                <form id="formpromo" >
                    <Grid container xs={12}>
                        <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={promo.id_Oficina} />
                        <input id="Id_Poi" name="Id_Poi" type="hidden" value={promo.id_Poi} />
                        <input id="	Id_PoiAction" name="Id_PoiAction" type="hidden" value={promo.id_PoiAction} />
                        <input id="	Id_Promocion" name="Id_Promocion" type="hidden" value={promo.id_Promocion} />
                        <Grid item xs={12} sm={2}>
                            <OthelloEdit label="Codigo" fieldname="CodigoPromo" currentvalue={promo.codigoPromo} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <OthelloEdit label="Promocion" fieldname="Promo" currentvalue={promo.promo} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <OthelloTimer label="Fecha Final" fieldname="FechValido" currentvalue={promo.fechValido} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <OthelloComboBox label='Activada' fieldname="Activada" items={OpcionSiNoChar} currentvalue={promo.activada} />
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid item xs={6} sm={2}>
                            <OthelloComboBox label='Codigo Auto' fieldname="CodigoAuto" items={OpcionSiNo} currentvalue={promo.codigoAuto} />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <OthelloEdit label='Pin Cupon' fieldname="PinCupon" currentvalue={promo.pinCupon} />
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <OthelloEdit label="Acceso Externo" fieldname="UrlExterna" currentvalue={promo.urlExterna} />
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid item xs={12}>
                            <OthelloEdit label="Info Adicional" fieldname="InfoAdd" currentvalue={promo.infoAdd} rows={2} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={2}>
                            <br />
                            <legend>Imagen Promocional</legend>
                            <ImageUpload
                                id="ImageUrlPromo" name="ImageUrlPromo"
                                imageUrl={promo.imageUrlPromo}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                    </Grid>
                </form>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    function renderParametrosBusqueda()
    {
      
        return (modoagenda ? "" :
            <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData margentop={1}>
                    <div>
                        <form id="formbusqueda" >
                            <Grid container mb={1}>
                                <Grid item xs={3} sm={2} md={2} lg={1} mt={1}>
                                    <Button color='info' size="sm" onClick={OnBuscarClick}>Buscar</Button>
                                </Grid>
                                    <Grid item xs={5} sm={5} md={4} lg={3}>
                                        <OthelloComboBox label='Idioma' fieldname="idioma" items={!loading ? idiomascombo : []} />
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} lg={2}>
                                        <OthelloComboBox label='Area' fieldname="id_area" items={!loading ? areascombo : []} onChange={onChangeAreaBusqueda}  />
                                </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={2}>
                                        {subareascombo != null && subareascombo.length > 0 ? <OthelloComboBox label='Sub Areas' fieldname="id_subarea" items={!loading ? subareascombo : []} /> : ""}
                                    </Grid>
                            </Grid>
                        </form>
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>)
    }
    //currentvalue={!loadingFiltros ? filtros.tipobusqueda : 0} 

    let busqueda = loading ? <p><CircularProgress color="secondary" /></p> : renderSearchPOIS(datapois)
   
    let edicion = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEditPOIS() : "";    

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    let paramsbsuqueda = renderParametrosBusqueda();

    let name = tipooficina == 3 ? "Establecimientos" : "Puntos de Interes";

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            {paramsbsuqueda}
            <Grid container>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />
                </Grid>
            </Grid>            
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData titulo={areaagenda != null ? areaagenda.cod_Area : name} margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {busqueda}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                {edicion}
            </Grid>            
        </Grid>
    );
}
